<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      scrollable
      persistent
      :fullscreen="$vuetify.breakpoint.xs"
      max-width="1024px"
    >
      <v-card>
        <v-toolbar
          flat
          color="secondary"
        >
          <div
            :class="[`${color}--text v-alert__border--has-color`]"
            class="v-alert__border v-alert__border--left"
          />

          <v-avatar
            v-if="icon"
            :color="color"
            size="36"
            class="mr-2"
          >
            <v-icon color="pred">
              {{ icon }}
            </v-icon>
          </v-avatar>

          <v-divider
            v-if="icon"
            vertical
            class="mr-2"
          />

          <v-toolbar-title v-if="title || subTitle">
            <div
              v-if="title"
              :class="[`${color}--text`]"
              class="subtitle-1"
            >
              {{ title }}
            </div>
            <div
              v-if="subTitle"
              class="caption grey--text text--lighten-1"
            >
              {{ subTitle }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            dark
            @click.native="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text ref="vCardText">
          <div
            class="mt-6"
            v-html="body"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DialogVisible from '../../mixins/dialogVisible'

export default {
  name      : 'GdprViewDialog',
  components: {},
  directives: {},
  mixins    : [DialogVisible],
  props     : {
    title: {
      type   : String,
      default: function () { return this.$t('Gdpr.Title') }
    },
    subTitle: {
      type   : String,
      default: ''
    },
    body: {
      type   : String,
      default: ''
    }
  },
  data () {
    return {
      color: 'pyellow',
      icon : 'mdi-album'
    }
  },
  computed: {},
  watch   : {
    isVisible (newVal) {
      if (!newVal && this.$refs.vCardText) this.$refs.vCardText.scrollTop = 0
    }
  },
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {}
}
</script>

<style scoped>

</style>
